import React from "react";
import {
    CardActions, Create, CreateButton, Datagrid, DateField, Edit, ExportButton, Filter, List, RefreshButton, SimpleForm, TextField, TextInput
} from "react-admin";

const PostActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
    <CreateButton basePath={basePath} />
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
      maxResults={10000}
    />
    <RefreshButton />
  </CardActions>
);
const MessageFilter = props => (
  <Filter {...props}>
    <TextInput label="Search by name" source="q" alwaysOn />
  </Filter>
);

export const MessageList = props => (
  <List {...props} filters={<MessageFilter />} actions={<PostActions />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="subject" />
      <TextField source="senderId" />
      <TextField source="recipientId" />
    </Datagrid>
  </List>
);

export const MessageCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="subject" />
      <TextInput source="senderId" />
      <TextInput source="recipientId" />
      <TextInput source="text" />
      <TextInput source="html" />
    </SimpleForm>
  </Create>
);

export const MessageEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled label="Id" source="id" />
      <TextInput source="subject" />
      <TextInput source="senderId" />
      <TextInput source="recipientId" />
      <TextInput source="text" />
      <TextInput source="html" />
      <DateField label="Created Date" source="createdAt" locales="en-GB" />
      <DateField label="Updated Date" source="updatedAt" locales="en-GB" />
    </SimpleForm>
  </Edit>
);
